import React, { useState } from 'react';
import { CheckCircle2, Shield, ArrowRight } from 'lucide-react';
import { Button, FadeIn } from './Shared';
export const FAQ = () => <section className="py-20 bg-white" data-id="element-128">
    <div className="max-w-3xl mx-auto px-6" data-id="element-129">
      <FadeIn data-id="element-130">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-center mb-12 text-brown" data-id="element-131">
          Preguntas Frecuentes & Glosario
        </h2>

        <div className="space-y-8 mb-16" data-id="element-132">
          <div className="bg-cream p-6 rounded-2xl" data-id="element-133">
            <h3 className="font-bold text-lg mb-2 text-terracotta" data-id="element-134">
              ¿Qué suplementos ayudan?
            </h3>
            <p className="text-brown/80" data-id="element-135">
              En tu farmacia local (CVS, Walgreens, Amazon) busca: Magnesio
              Glicinato (para el sueño) y Omega-3 (para la inflamación). Son
              seguros para la mayoría, pero pregunta a tu farmacéutico si ya
              tomas otras medicinas.
            </p>
          </div>

          <div className="bg-cream p-6 rounded-2xl" data-id="element-136">
            <h3 className="font-bold text-lg mb-2 text-terracotta" data-id="element-137">
              ¿Cuánto tardaré en ver resultados?
            </h3>
            <p className="text-brown/80" data-id="element-138">
              Si sigues el Ancla Glucémica (comida) y el Ancla Nerviosa
              (respiración), verás cambios en 48 a 72 horas. Los 14 días son
              para consolidar el hábito.
            </p>
          </div>
        </div>

        <div className="border-t border-terracotta/20 pt-12" data-id="element-139">
          <h3 className="text-2xl font-playfair font-bold mb-6 text-center" data-id="element-140">
            Glosario de Términos
          </h3>
          <div className="grid md:grid-cols-3 gap-6 text-center" data-id="element-141">
            <div className="p-4" data-id="element-142">
              <h4 className="font-bold text-terracotta mb-2" data-id="element-143">Hipotálamo</h4>
              <p className="text-sm text-brown/70" data-id="element-144">
                El jefe de tu temperatura.
              </p>
            </div>
            <div className="p-4" data-id="element-145">
              <h4 className="font-bold text-terracotta mb-2" data-id="element-146">Glucemia</h4>
              <p className="text-sm text-brown/70" data-id="element-147">
                La cantidad de azúcar en tu sangre.
              </p>
            </div>
            <div className="p-4" data-id="element-148">
              <h4 className="font-bold text-terracotta mb-2" data-id="element-149">Cortisol</h4>
              <p className="text-sm text-brown/70" data-id="element-150">
                La hormona del estrés que "calienta" el cuerpo.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </div>
  </section>;
export const Pricing = () => <section id="pricing" className="py-24 bg-brown text-cream relative overflow-hidden" data-id="element-151">
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-20" data-id="element-152">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-terracotta blur-[100px]" data-id="element-153"></div>
    </div>

    <div className="max-w-4xl mx-auto px-6" data-id="element-154">
      <FadeIn data-id="element-155">
        <div className="text-center mb-12" data-id="element-156">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4 text-white" data-id="element-157">
            Tu Paz Mental No Tiene Precio
          </h2>
          <p className="text-xl text-cream/80" data-id="element-158">
            Pero recuperar tus noches de sueño sí tiene un atajo.
          </p>
        </div>

        <div className="bg-white text-brown rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto relative border-4 border-gold/30" data-id="element-159">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold text-brown font-bold px-6 py-2 rounded-full text-sm tracking-wide uppercase shadow-md" data-id="element-160">
            Oferta Especial
          </div>

          <div className="text-center mb-8" data-id="element-161">
            <h3 className="text-2xl font-playfair font-bold mb-2" data-id="element-162">
              Guía Maestra: Bochornos a Raya
            </h3>
            <p className="text-brown/60 mb-6" data-id="element-163">
              El Protocolo Completo de 14 Días (PDF Digital)
            </p>

            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-164">
              <span className="text-3xl text-brown/40 line-through font-light" data-id="element-165">
                $47.00
              </span>
              <span className="text-6xl font-bold text-terracotta" data-id="element-166">
                $6<span className="text-2xl" data-id="element-167">.39 USD</span>
              </span>
            </div>
            <p className="text-sm text-green-600 font-medium bg-green-50 inline-block px-3 py-1 rounded-full" data-id="element-168">
              Ahorras $40.61 hoy
            </p>
          </div>

          <ul className="space-y-4 mb-10" data-id="element-169">
            {['Acceso inmediato al protocolo de 6 Anclas', 'Checklists diarios para implementar sin estrés', 'Hojas de trabajo prácticas y directas', 'Diseñado para la mujer latina en USA', 'Formato PDF compatible con cualquier celular o tablet'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-170">
                <CheckCircle2 className="w-6 h-6 text-terracotta shrink-0" data-id="element-171" />
                <span className="font-medium text-brown/90" data-id="element-172">{item}</span>
              </li>)}
          </ul>

          <Button className="w-full py-5 text-xl flex items-center justify-center gap-2 group" data-id="element-173">
            Sí, Quiero Mi Protocolo Ahora
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-174" />
          </Button>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-brown/50" data-id="element-175">
            <Shield className="w-4 h-4" data-id="element-176" />
            <span data-id="element-177">Pago 100% Seguro. Entrega Inmediata.</span>
          </div>
        </div>
      </FadeIn>
    </div>
  </section>;
const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-178">
      <div className="bg-white text-brown rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-179">
        <div className="sticky top-0 bg-white border-b border-brown/10 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-180">
          <h3 className="text-xl font-playfair font-bold text-brown" data-id="element-181">
            {title}
          </h3>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-cream flex items-center justify-center text-brown hover:bg-cream-dark transition-colors" data-id="element-182">
            ✕
          </button>
        </div>
        <div className="px-6 py-6 text-sm leading-relaxed text-brown/80 space-y-4" data-id="element-183">
          {children}
        </div>
      </div>
    </div>;
};
export const Footer = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-brown-light text-cream/60 py-12 text-sm" data-id="element-184">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-6" data-id="element-185">
          <div className="font-playfair font-bold text-xl text-cream/80 mb-6" data-id="element-186">
            BOCHORNOS A RAYA
          </div>

          <div className="p-6 bg-brown/50 rounded-xl border border-white/5 text-xs leading-relaxed text-left" data-id="element-187">
            <p className="font-bold text-cream/80 mb-2" data-id="element-188">
              DISPOSICIÓN LEGAL (DISCLAIMER)
            </p>
            <p data-id="element-189">
              Este producto tiene fines exclusivamente informativos y
              educativos. No constituye asesoramiento médico, diagnóstico o
              tratamiento profesional. La información aquí contenida no debe
              reemplazar la consulta con su médico, especialmente en casos de
              condiciones preexistentes o uso de medicamentos recetados. El
              autor no se hace responsable por el uso de la información
              provista. Los resultados individuales pueden variar. Consulte con
              su especialista antes de iniciar cualquier cambio en su dieta o
              rutina de suplementos.
            </p>
          </div>

          <div className="flex items-center justify-center gap-6" data-id="element-190">
            <button onClick={() => setPrivacyOpen(true)} className="underline underline-offset-4 hover:text-cream transition-colors" data-id="element-191">
              Privacy Policy
            </button>
            <span className="text-cream/30" data-id="element-192">|</span>
            <button onClick={() => setTermsOpen(true)} className="underline underline-offset-4 hover:text-cream transition-colors" data-id="element-193">
              Terms of Service
            </button>
          </div>

          <p data-id="element-194">
            © {new Date().getFullYear()} Bochornos a Raya. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Privacy Policy" data-id="element-195">
        <p data-id="element-196">
          <strong data-id="element-197">Última actualización:</strong>{' '}
          {new Date().toLocaleDateString('es-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-198">
          Bochornos a Raya ("nosotros") respeta su privacidad. Esta política
          describe cómo recopilamos, usamos y protegemos su información
          personal.
        </p>
        <p data-id="element-199">
          <strong data-id="element-200">Información que recopilamos:</strong> Cuando usted realiza una
          compra, recopilamos su nombre, dirección de correo electrónico e
          información de pago. No almacenamos datos de tarjetas de crédito
          directamente; estos son procesados por nuestro proveedor de pagos
          seguro.
        </p>
        <p data-id="element-201">
          <strong data-id="element-202">Uso de la información:</strong> Utilizamos su información para
          procesar su pedido, enviarle el producto digital adquirido y
          comunicarnos con usted sobre su compra. No vendemos, alquilamos ni
          compartimos su información personal con terceros con fines de
          marketing.
        </p>
        <p data-id="element-203">
          <strong data-id="element-204">Cookies:</strong> Nuestro sitio puede utilizar cookies para
          mejorar su experiencia de navegación y analizar el tráfico del sitio.
        </p>
        <p data-id="element-205">
          <strong data-id="element-206">Seguridad:</strong> Implementamos medidas de seguridad
          razonables para proteger su información personal contra acceso no
          autorizado.
        </p>
        <p data-id="element-207">
          <strong data-id="element-208">Sus derechos:</strong> Usted tiene derecho a solicitar acceso,
          corrección o eliminación de sus datos personales. Para ejercer estos
          derechos, contáctenos por correo electrónico.
        </p>
        <p data-id="element-209">
          <strong data-id="element-210">Contacto:</strong> Si tiene preguntas sobre esta política de
          privacidad, puede contactarnos a través de nuestro sitio web.
        </p>
      </Modal>

      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Terms of Service" data-id="element-211">
        <p data-id="element-212">
          <strong data-id="element-213">Última actualización:</strong>{' '}
          {new Date().toLocaleDateString('es-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>
        <p data-id="element-214">
          Al comprar y/o utilizar el producto digital "Bochornos a Raya: El
          Protocolo de 14 Días", usted acepta los siguientes términos y
          condiciones.
        </p>
        <p data-id="element-215">
          <strong data-id="element-216">Naturaleza del producto:</strong> Este es un producto digital
          (PDF) con fines exclusivamente informativos y educativos. No
          constituye asesoramiento médico, diagnóstico o tratamiento
          profesional.
        </p>
        <p data-id="element-217">
          <strong data-id="element-218">Licencia de uso:</strong> Al completar su compra, usted recibe
          una licencia personal e intransferible para usar el contenido. Queda
          prohibida la reproducción, distribución, reventa o compartición del
          material sin autorización expresa.
        </p>
        <p data-id="element-219">
          <strong data-id="element-220">Resultados:</strong> Los resultados individuales pueden
          variar. No garantizamos resultados específicos. Siempre consulte con
          su profesional de salud antes de realizar cambios en su dieta o
          rutina.
        </p>
        <p data-id="element-221">
          <strong data-id="element-222">Política de reembolso:</strong> Debido a la naturaleza digital
          del producto, todas las ventas son finales. Si experimenta problemas
          técnicos para acceder al producto, contáctenos y le asistiremos.
        </p>
        <p data-id="element-223">
          <strong data-id="element-224">Propiedad intelectual:</strong> Todo el contenido, incluyendo
          texto, diseño y estructura, es propiedad de Bochornos a Raya y está
          protegido por las leyes de derechos de autor.
        </p>
        <p data-id="element-225">
          <strong data-id="element-226">Limitación de responsabilidad:</strong> En ningún caso seremos
          responsables por daños directos, indirectos o consecuentes derivados
          del uso de este producto.
        </p>
        <p data-id="element-227">
          <strong data-id="element-228">Contacto:</strong> Para cualquier consulta sobre estos
          términos, puede contactarnos a través de nuestro sitio web.
        </p>
      </Modal>
    </>;
};